import cx from 'classnames';
import { useState } from 'react';
import { ColorPickerIcon } from '../../../icons/ColorPickerIcon';
import styles from './EyeDropperButton.module.scss';

export const EyeDropperButton = ({ onChange, render }) => {
  const [active, setActive] = useState(false);
  const supported = 'EyeDropper' in window
  if (!supported) {
    return null;
  }

  const handleClick = async () => {
    setActive(true)
    const eyeDropper = new window.EyeDropper();

    try {
      const selectedColor = await eyeDropper.open();
      if (selectedColor.sRGBHex) {
        onChange(selectedColor.sRGBHex);
      } else {
        // TODO: log error here
      }
    } catch (err) {
        // ignore this, color selection was cancelled
    } finally {
      setActive(false);
    }
  }

  if (render) {
    return render({ active, onClick: handleClick })
  }

  return (
    <button className={cx(styles.button, active && styles.active)} onClick={handleClick}>
      <ColorPickerIcon />
    </button>
  )
}